// components/InfoCard.tsx
import React from "react";
import "./style.scss";
const RecommendationAI = ({ recommendation, }) => {
    return (React.createElement("div", { className: "recommendation-ai" }, recommendation && recommendation.length > 0 ? (React.createElement("ul", { className: "recommendation-list" }, recommendation.map((item, index) => (React.createElement("li", { key: index, className: "recommendation-item" },
        React.createElement("span", { className: "recommendation-bullet" }),
        React.createElement("span", { className: "recommendation-text" }, item)))))) : (React.createElement("p", { className: "recommendation-no-data" }, "No recommendations available"))));
};
export default RecommendationAI;
